import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b699700"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Base Info", -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "主图", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "请尽量选择经典年代的照片，如果列出的抓取照片没有合适的，请直接贴原图链接在输入框", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "choose-thumbnail-holder" }
const _hoisted_11 = ["src", "onClick"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "style-list" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "在线试听链接", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "style-list" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "删除本条，将本条信息合并到 ID->", -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "style-list" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "拉取discogs/网易/douban数据", -1))
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_EnumEditor = _resolveComponent("EnumEditor")!
  const _component_editor_upload = _resolveComponent("editor-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
    title: _ctx.dialogTitle
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleCombine(2)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 拉取Discog ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleCombine(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 合 并 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.dialogFormVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.doConfirmEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (!_ctx.isCombine)
        ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            model: _ctx.formEditArtist,
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_form_item, { label: "名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formEditArtist.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formEditArtist.name) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form_edited()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "英文译名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formEditArtist.name_roman,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formEditArtist.name_roman) = $event)),
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.form_edited()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "中文译名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formEditArtist.name_cn_simp,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formEditArtist.name_cn_simp) = $event)),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form_edited()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "成立" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formEditArtist.begin_year,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formEditArtist.begin_year) = $event)),
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.form_edited()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "解散/死亡" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formEditArtist.end_year,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formEditArtist.end_year) = $event)),
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.form_edited()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EnumEditor, {
                        modelValue: _ctx.formEditArtist.type,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formEditArtist.type) = $event)),
                        enums: {'0':'未分配', '1':'艺人', '2':'乐队/组合', '5':'管弦乐团', '10':'合集'},
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.form_edited()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "简介" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formEditArtist.profile,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formEditArtist.profile) = $event)),
                        type: "textarea",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.form_edited()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEditArtist.links, (link, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, "[ " + _toDisplayString(link.site) + " ]", 1),
                        _createElementVNode("span", {
                          class: "btn-mini",
                          onClick: ($event: any) => (_ctx.removeLinkIndex(index))
                        }, "x", 8, _hoisted_4)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.formEditArtist.primary_img) + " ", 1),
                    _hoisted_8,
                    _createElementVNode("img", {
                      class: "img-fluid",
                      src: _ctx.formEditArtist.primary_img
                    }, null, 8, _hoisted_9),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formEditArtist.primary_img) = $event)),
                      class: "form-control",
                      onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.form_edited && _ctx.form_edited(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.formEditArtist.primary_img]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEditArtist.images, (img, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("img", {
                          src: img.resource_url,
                          class: "choose-thumbnail",
                          onClick: ($event: any) => (_ctx.choose_thumbnail(index))
                        }, null, 8, _hoisted_11),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((img.resource_url) = $event),
                          class: "form-control",
                          onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.form_edited && _ctx.form_edited(...args)))
                        }, null, 40, _hoisted_12), [
                          [_vModelText, img.resource_url]
                        ]),
                        _createElementVNode("span", {
                          class: "btn-mini",
                          onClick: ($event: any) => (_ctx.removeImgIndex(index))
                        }, "x", 8, _hoisted_13)
                      ]))
                    }), 128)),
                    _createVNode(_component_editor_upload, {
                      modelValue: _ctx.newImage,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newImage) = $event)),
                      onChange: _ctx.handleUploadNewImage,
                      "record-id": _ctx.formEditArtist._id
                    }, null, 8, ["modelValue", "onChange", "record-id"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEditArtist.online_links, (link, index) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: index,
                      label: link.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: link.url,
                          "onUpdate:modelValue": ($event: any) => ((link.url) = $event),
                          onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.form_edited()))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])), [
            [_directive_loading, _ctx.loadings.formLoading]
          ])
        : _createCommentVNode("", true),
      (_ctx.isCombine==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", null, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.combineId,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.combineId) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCombine==2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_EnumEditor, {
                  modelValue: _ctx.combineIdFrom,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.combineIdFrom) = $event)),
                  enums: {'discogs':'discogs','netease':'网易云'},
                  class: "mr-3",
                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.form_edited()))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.combineId,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.combineId) = $event)),
                  onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.form_edited()))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}